// extracted by mini-css-extract-plugin
module.exports = {"abtn_box":"Abutton_abtn_box__2mgpp","btn_diamond":"Abutton_btn_diamond__61Ak0","btn_bagcolor":"Abutton_btn_bagcolor__1Pywc"};